import { createSlice } from '@reduxjs/toolkit';

import { AddToGroupStepType } from '~/enums/AddToGroupType';

import { State } from './types';

const initialState: State = {
  columnOrder: [],
  currentTableView: undefined,
  currentAddToGroupStep: AddToGroupStepType.GROUP,
  selectedDocumentId: undefined,
  selectedGroupId: undefined,
};

export default createSlice({
  name: 'documents_v2',
  initialState,
  selectors: {
    selectCurrentTableView: (state) => state.currentTableView,
    selectCurrentAddToGroupStep: (state) => state.currentAddToGroupStep,
    selectSelectedDocumentId: (state) => state.selectedDocumentId,
    selectSelectedGroupId: (state) => state.selectedGroupId,
  },
  reducers: {
    setColumnOrder: (state, action) => {
      state.columnOrder = action.payload;
    },
    setCurrentTableView: (state, action) => {
      state.currentTableView = action.payload;
    },
    setCurrentAddToGroupStep: (
      state,
      action: { payload: AddToGroupStepType },
    ) => {
      state.currentAddToGroupStep = action.payload;
    },
    setSelectedDocumentId: (state, action) => {
      state.selectedDocumentId = action.payload;
    },
    setSelectedGroupId: (state, action) => {
      state.selectedGroupId = action.payload;
    },
  },
});
